export default class ConfigBranchActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_BRANCH='GET_HELPER_BRANCH';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: ConfigBranchActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: ConfigBranchActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: ConfigBranchActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: ConfigBranchActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: ConfigBranchActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: ConfigBranchActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: ConfigBranchActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: ConfigBranchActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: ConfigBranchActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: ConfigBranchActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: ConfigBranchActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: ConfigBranchActions.GET_HELPER_BRANCH,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: ConfigBranchActions.ERROR_SERVER,
      payload: error
    };
  }
}